import { useEffect } from "react";

export type ModalConfig = {
  id: string;
  shouldShow: boolean;
  action: () => void;
};

const shownModalIds = new Set<string>();

export const resetModalQueue = () => {
  shownModalIds.clear();
};

export const useModalQueue = (modalConfigs: ModalConfig[]) => {
  useEffect(() => {
    const modalToShow = modalConfigs.find(
      (config) => config.shouldShow && !shownModalIds.has(config.id),
    );

    if (modalToShow) {
      shownModalIds.add(modalToShow.id);
      modalToShow.action();
    }
  }, [modalConfigs]);
};
